/* eslint-disable */
import MFBasketsOrders from '../MutualFundsBaskets/MFBasketsOrders'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import MFIndividualOrders from './MFIndividualOrders'
import { useEffect } from 'react'
import PostHogTracker from '../../utils/PostHogTracker'

const MFOrders = () => {
  useEffect(() => {
    // Track orders tab clicked
    PostHogTracker.ordersTabClicked()
    PostHogTracker.pageViewed('Order History')
  }, [])
  return (
    <>
      <div className='mx-auto max-w-[1128px]'>
        <h2 className='px-4 pb-3 pt-4 font-IBM text-lg font-semibold leading-6 text-black-950 lg:px-0 lg:text-xl'>
          My Orders
        </h2>
      </div>

      <div className='mx-auto max-w-[1128px]'>
        <Tabs defaultValue='Goals' className='relative mr-auto w-full'>
          <div className='px-4 lg:px-0'>
            <TabsList className='mx-auto grid h-12 max-w-[360px] grid-cols-2 rounded-full'>
              <TabsTrigger value='Goals' className='relative h-10 px-2 text-sm leading-5 md:px-4'>
                Goals
              </TabsTrigger>

              <TabsTrigger
                value='Mutual Funds'
                className='relative h-10 px-2 text-sm leading-5 md:px-4'
              >
                <span className='sm:hidden'>Funds</span>
                <span className='hidden sm:inline'>Mutual Funds</span>
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value='Mutual Funds'>
            <MFIndividualOrders />
          </TabsContent>

          <TabsContent value='Goals'>
            <MFBasketsOrders />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}

export default MFOrders
